import * as React from "react";
import { Modal, Button, Tabs, Tab, Card, ListGroup, Row, Col } from "react-bootstrap";
import { getTransactions } from "../../services/apiService";

export default function TransactionsModal({ show, userId, onClose }) {
  const [transactions, setTransactions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (show && userId) {
      const fetchTransactions = async () => {
        setLoading(true);
        setError(null);
        try {
          const response = await getTransactions(userId);
          setTransactions(response.data.transactions || []);
        } catch (e) {
          console.error("Error fetching transactions:", e);
          setError("Error loading transactions");
        }
        setLoading(false);
      };
      fetchTransactions();
    } else {
      setTransactions([]);
      setLoading(false);
      setError(null);
    }
  }, [show, userId]);

  const { income, expense, totalIncome, totalExpense } = React.useMemo(() => {
    const income = transactions.filter(t => t.type === 'income');
    const expense = transactions.filter(t => t.type === 'expense');
    const totalIncome = income.reduce((sum, t) => sum + t.amount, 0);
    const totalExpense = expense.reduce((sum, t) => sum + t.amount, 0);
    return { income, expense, totalIncome, totalExpense };
  }, [transactions]);

  const renderTransactionList = (items) => {
    if (items.length === 0) {
      return <p className="text-muted">No transactions in this category.</p>;
    }
    return (
          <ListGroup variant="flush">
            {items.map(t => (
              <ListGroup.Item
                key={t.id}
                className="d-flex justify-content-between align-items-start"
                style={{
                  background: '#ffffff',
                  color: '#0f172a',
                  borderColor: '#e5e7eb',
                }}
              >
            <div>
              <div className="fw-bold">{t.category_name}</div>
              <small className="text-muted">{t.description || 'No description'}</small>
              <br />
              <small>{new Date(t.date_time).toLocaleString()}</small>
            </div>
            <span className="fw-bold">{t.amount}</span>
          </ListGroup.Item>
        ))}
      </ListGroup>
    );
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header
        closeButton
        style={{
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
          color: '#0f172a',
        }}
      >
        <Modal.Title style={{ color: '#0f172a' }}>Transactions for User ID: {userId}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', background: '#f8fafc', color: '#0f172a' }}>
        {error && <div className="alert alert-danger">{error}</div>}
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <Row className="mb-3 text-center">
              <Col>
                <Card
                  style={{
                    background: 'linear-gradient(135deg, #e0f2fe, #ecfeff)',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <Card.Body>
                    <Card.Title>Total Income</Card.Title>
                    <Card.Text className="fs-4 fw-bold">{totalIncome}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card
                  style={{
                    background: 'linear-gradient(135deg, #fee2e2, #eef2ff)',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <Card.Body>
                    <Card.Title>Total Expense</Card.Title>
                    <Card.Text className="fs-4 fw-bold">{totalExpense}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Tabs
              defaultActiveKey="income"
              id="transaction-tabs"
              className="mb-3"
              fill
              style={{
                '--bs-nav-tabs-border-color': '#e5e7eb',
                '--bs-nav-tabs-link-active-bg': '#e0f2fe',
                '--bs-nav-tabs-link-active-color': '#0f172a',
                '--bs-nav-tabs-link-color': '#0f172a',
              }}
            >
              <Tab eventKey="income" title={`Income (${income.length})`}>
                {renderTransactionList(income)}
              </Tab>
              <Tab eventKey="expense" title={`Expense (${expense.length})`}>
                {renderTransactionList(expense)}
              </Tab>
            </Tabs>
          </>
        )}
      </Modal.Body>
      <Modal.Footer
        style={{
          background: '#ffffff',
          borderTop: '1px solid #e5e7eb',
        }}
      >
        <Button
          variant="link"
          onClick={onClose}
          style={{
            background: 'linear-gradient(135deg, #2563eb, #22c55e)',
            border: 'none',
            color: '#0b1220',
            fontWeight: 700,
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
